import axios from '@/utils/request'

export default {
    // 2020-08-08
    search(params) {
        return axios.get('/fileserver/download-files', params);
    },
    // 2020-08-08
    download(id) {
        return axios.put('/fileserver/download-files/' + id, {});
    },
    // 2020-12-29
    waitingDownloadCount() {
        return axios.get('/fileserver/download-files/waiting-download-count');
    },
}
